import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import api from "../lib/api";

/* Most-viewed destination guides of the week — social proof + content discovery. */
export default function TrendingPlaces({ limit = 8 }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/geo-content-trending", { params: { days: 7, limit } })
      .then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [limit]);

  if (!items || items.length === 0) return null;

  return (
    <div className="bg-white border border-zinc-300 p-5" data-testid="trending-places">
      <div className="font-heading font-900 text-lg mb-3 flex items-center gap-2">
        <Flame className="w-5 h-5 text-[#EA4335]" /> Trending this week
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {items.map((p, i) => (
          <Link key={p.slug} to={`/explore/${p.slug}`} data-testid={`trending-${p.slug.split("/").pop()}`}
            className="group border border-zinc-200 px-3 py-2.5 hover:border-[#EA4335] transition-colors">
            <span className="flex items-baseline gap-2">
              <span className="font-heading font-900 text-lg text-zinc-300 group-hover:text-[#EA4335]">{i + 1}</span>
              <span className="min-w-0">
                <span className="block text-sm font-800 truncate">{p.name}</span>
                <span className="block text-xs text-muted-foreground truncate">
                  {[p.place_type, p.country !== p.name ? p.country : null].filter(Boolean).join(" · ")}
                </span>
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
